import React, { Component } from 'react';
import { TourPointText } from "./TourPointText";

interface Props {
  point: any;
  onClicked?: () => void | null;
}


export class TourPointContent extends Component<Props, {}> {
  constructor(props: Props) {
    super(props);

    this.renderTourPointTextWithBackground = this.renderTourPointTextWithBackground.bind(this);
  }

  renderTourPointTextWithBackground() {
    const { point } = this.props;

    if (point.background === "full-left-gradient") {
      return (
        <div className="absolute top-0 left-0 right-0 sm:right-auto bottom-0 h-full w-full sm:w-1/2 bg-gradient-to-t sm:bg-gradient-to-r from-theme-900-opacity-80 to-transparent pointer-events-none" style={{
          height: "100vh",
        }}>
          <TourPointText point={point} />
        </div>
      );
    } else if (point.background === "full-right-gradient") {
      return (
        <div className="absolute top-0 right-0 left-0 sm:left-auto bottom-0 h-full w-full sm:w-1/2 bg-gradient-to-t sm:bg-gradient-to-l from-theme-900-opacity-80 to-transparent pointer-events-none" style={{
          height: "100vh",
        }}>
          <TourPointText point={point} />
        </div>
      );
    } else if (point.background === "full-bottom-gradient") {
      return (
        <div className="absolute top-auto bottom-0 right-0 left-0 sm:left-auto bottom-0 h-full sm:h-1/2 w-full bg-gradient-to-t from-theme-900-opacity-80 to-transparent pointer-events-none" style={{
          height: "50vh",
        }}>
          <TourPointText point={point} />
        </div>
      );
    }

    return (<TourPointText point={point} />);
  }

  render() {
    const { point } = this.props;

    // if a bg video or map, render the fullscreen version
    if (point.background_video || point.background_image || point.map || point.background === "full-left-gradient" || point.background === "full-right-gradient" || point.background == "full-bottom-gradient") {

      return (
        <div className="fixed z-10 text-white w-screen h-screen pointer-events-none">
          {point.background_video ?
            <div className="absolute full-cover-height w-screen h-screen inset-0 overflow-hidden bg-theme-900 top-0 left-0 right-0 bottom-0">
              <video
                className="lazy w-screen shadow-xl ring-1 ring-black ring-opacity-5 absolute left-0 right-0 full-cover-height w-screen h-screen object-cover"
                playsInline
                autoPlay
                muted
                loop
              >
                <source src={point.background_video} type="video/mp4" />
              </video>
            </div>
          : ""}

          {point.background_image ?
            <div className="absolute full-cover-height w-screen h-screen inset-0 overflow-hidden bg-theme-900 top-0 left-0 right-0 bottom-0">
              <div className="h-screen w-screen bg-cover bg-center" style={{"backgroundImage": `url('${point.background_image}')`}}></div>
            </div>
          : ""}


          {point.map ?
            <div className="absolute full-cover-height w-screen h-screen inset-0 overflow-hidden bg-theme-900 top-0 left-0 right-0 bottom-0 pointer-events-auto">
              <iframe style={{width:"100vw", height:"100vh", border:"0"}}  frameBorder="0"  referrerPolicy="no-referrer-when-downgrade"  src={point.map}  allowFullScreen></iframe>
            </div>
          : ""}

          {this.renderTourPointTextWithBackground()}
        </div>
      );

    } else {

      // otherwise, render the tour point text only
      return (
        <TourPointText point={point} />
      );
    }
  }
}
